import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const OOP_Templates = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Function Templates, Class Templates & Standard Template Library (STL)"
      videos={[
        "https://www.youtube.com/embed/Q7LWewcNpIg", // Template in C++ | Function & Class Templates
        "https://www.youtube.com/embed/bP1ceQFbohM", // Function Templates in C++
        "https://www.youtube.com/embed/CWj7lLY2GLA", // Class Templates in C++
        "https://www.youtube.com/embed/fmKNmoZxiVU", // Standard Template Library (STL) in C++
      ]}
      takeaways={[
        { text: "Understand function templates and how they provide generic programming." },
        { text: "Learn how to create and use class templates in C++." },
        { text: "Explore the Standard Template Library (STL) and its components." },
        { text: "Practice implementing sequential containers like vectors and lists." },
      ]}
      questions={[
        "List the Standard Template Library components in C++ and briefly explain a sequential container with an example.",
      ]}
      exampleVideos={[]} // No example question videos provided
    />
);
}

export default OOP_Templates;
